<template>
  <div>
    <Dialog
      :visible.sync="modalShow"
      :modal="true"
      :style="{ width: $isMobile() ? '100vw' : '40vw' }"
      :showHeader="false"
      :closable="true"
      :dismissableMask="true"
      :position="$isMobile() ? 'top' : 'center'"
      contentStyle="padding: 0; border-radius: 8px; overflow: hidden;"
      class="quick-search-dialog"
    >
      <div class="search-header p-d-flex p-ai-center p-p-3">
        <i class="pi pi-search p-mr-3" style="font-size: 1.2rem; color: #6c757d;"></i>
        <InputText
          ref="searchInput"
          type="text"
          v-model="searchQuery"
          @input="handleQuery"
          @keydown.up.prevent="moveActive(-1)"
          @keydown.down.prevent="moveActive(1)"
          @keydown.enter.prevent="selectActive"
          placeholder="Procurar PATs..."
          class="p-mr-2 w-full"
        />
        <span class="shortcut p-mr-2">[esc]</span>
        <Button
          icon="pi pi-times"
          class="p-button-text p-button-secondary"
          @click="close"
        />
      </div>

      <div class="search-body p-p-3">
        <div v-if="searchQuery.length < minSearchLength" class="p-grid">
          <div class="p-col-12 p-md-6">
            <h5>ATALHOS RÁPIDOS</h5>
            <ul class="search-list">
              <li v-for="item in popularSearches" :key="item.label">
                <a @click="handleItemClick(item)">
                  <i :class="item.icon"></i>
                  <span>{{ item.label }}</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="p-col-12 p-md-6">
            <h5>&nbsp;</h5>
            <ul class="search-list">
              <li v-for="item in othersPages" :key="item.label">
                <a @click="handleItemClick(item)">
                  <i :class="item.icon"></i>
                  <span>{{ item.label }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div v-else>
          <div v-if="loading" class="spinner-container p-d-flex p-jc-center p-p-3">
            <ProgressSpinner style="width:30px;height:30px" strokeWidth="6" />
          </div>

          <div v-if="!loading && listData.length > 0">
            <h5>Resultados da Pesquisa</h5>
            <ul class="search-list results-list">
              <li v-for="(item, idx) in listData" :key="item.id">
                <a
                  @click="handlePatClick(item)"
                  :class="{ 'search-item--active': activeIndex === idx }"
                >
                  <div class="results-list-content">
                    <span class="result-id"><b>PAT {{ item.id }}</b> - {{ item.client.name }}</span>
                    <span class="result-detail p-mt-1">{{ item.resume || 'Sem resumo' }}</span>
                    <small class="p-mt-1">
                        {{ item.status || 'Sem estado' }} | {{ item.equipment ? item.equipment.brand + ' - ' + item.equipment.model + ' - ' + item.equipment.serie : 'Sem equipamento' }}
                    </small>
                  </div>
                  <div class="results-list-icon">
                    <i class="pi pi-arrow-circle-right"></i>
                  </div>
                </a>
              </li>
            </ul>
          </div>

          <div
            v-if="!loading && listData.length === 0 && lastSearchTerm.length > 0"
            class="p-text-center p-p-4"
            style="color: #6c757d;"
          >
            <i class="pi pi-exclamation-circle p-mr-2" style="font-size: 1.2rem"></i>
            Nenhum resultado encontrado para "<strong>{{ lastSearchTerm }}</strong>".
          </div>
        </div>

      </div>
    </Dialog>
  </div>
</template>

<script>

import ProgressSpinner from 'primevue/progressspinner';
import patsService from "../../services/pat.service";

export default {
  name: "AppQuickSearch",
  components: { ProgressSpinner },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
        modalShow: false,
        searchQuery: "",
        searchTimeout: null,
        searchDelay: 800,
        minSearchLength: 1,
        lastSearchTerm: "",
        loading: false,
        activeIndex: -1,

        listData: [],

        popularSearches: [
            { label: "Agenda", icon: "pi pi-fw pi-calendar", to: "/support" },
            { label: "Ordens de Serviço", icon: "pi pi-fw pi-list", to: "/serviceOrders/lg" },
            { label: "Mapa", icon: "pi pi-fw pi-map-marker", to: "/support/map" },
            { label: "Tickets", icon: "pi pi-fw pi-ticket", to: "/helpdesk-tickets" },
        ],
        othersPages: [
            { label: "Clientes", icon: "pi pi-users", to: "/clients" },
            { label: "Entidades", icon: "pi pi-building", to: "/entities" },
            { label: "Equipamentos", icon: "pi pi-cog", to: "/equipments" },
            { label: "PATs", icon: "pi pi-box", to: "/pats" },
      ],
    };
  },
  computed: {
    selectableItems() {
      if (this.searchQuery.length < this.minSearchLength) {
        return [];
      }
      return this.listData;
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(newVal) {
        this.modalShow = newVal;
      }
    },
    modalShow(newVal) {
      if (newVal) {
        this.activeIndex = this.selectableItems.length > 0 ? 0 : -1;
        setTimeout(() => {
            this.$refs.searchInput.$el.focus()
        }, 400);
        window.addEventListener("keydown", this.handleEsc);
      } else {
        window.removeEventListener("keydown", this.handleEsc);
        this.searchQuery = "";
        this.listData = [];
        this.lastSearchTerm = "";

        if (!newVal && this.show) {
          this.$emit("close");
        }
      }
    },
    selectableItems(newVal) {
      this.activeIndex = newVal.length > 0 ? 0 : -1;
    },
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleEsc);
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  },
  methods: {
    async fetchData(search = '') {
        try {
            let pats = await patsService.query({ 'search': search });
            this.listData = pats;
            this.lastSearchTerm = search;
        } catch (error) {
            console.error('Error fetching PATs:', error);
            this.listData = [];
        } finally {
            this.loading = false
        }
    },
    handleQuery() {
      const searchTerm = this.searchQuery || '';

      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      if (searchTerm.length < this.minSearchLength) {
        this.listData = [];
        this.lastSearchTerm = "";
        this.loading = false;
        return;
      }

      if (searchTerm === this.lastSearchTerm) {
        this.loading = false;
        return;
      }

      this.loading = true;

      this.searchTimeout = setTimeout(() => {
        this.fetchData(searchTerm);
      }, this.searchDelay);
    },
    close() {
      this.$emit("close");
    },
    handleEsc(event) {
      if (event.key === "Escape") {
        this.close();
      }
    },
    handleItemClick(item) {
        this.close();
        this.$router.push(item.to).catch(() => {});
    },
    handlePatClick(item) {
        this.close();
        this.$router.push(`/pats/${item.id}`).catch(() => {});
    },
    moveActive(direction) {
      const len = this.selectableItems.length;
      if (len === 0) return;
      this.activeIndex = (this.activeIndex + direction + len) % len;

      this.$nextTick(() => {
        const activeEl = this.$el.querySelector('.search-item--active');
        if (activeEl) {
          activeEl.scrollIntoView({ block: 'nearest' });
        }
      });
    },
    selectActive() {
      if (this.activeIndex >= 0 && this.activeIndex < this.selectableItems.length) {
        const item = this.selectableItems[this.activeIndex];
        if (this.searchQuery.length < this.minSearchLength) {
          this.handleItemClick(item);
        } else {
          this.handlePatClick(item);
        }
      }
    },
  },
};
</script>

<style scoped>

::v-deep .quick-search-dialog .p-dialog-content {
  padding: 0;
  border-radius: 8px;
  background-color: #ffffff;
}

.search-header {
  border-bottom: 1px solid #dee2e6;
  background-color: #ffffff;
}

.search-header .p-inputtext {
  border: 0;
  box-shadow: none;
  font-size: 1rem;
}
.search-header .p-inputtext:focus {
  box-shadow: none;
}

.shortcut {
  color: #6c757d;
  font-size: 0.8rem;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 2px 4px;
}

.search-body {
  background-color: #f7f9fc;
  max-height: 60vh;
  overflow-y: auto;
}

.search-body h5 {
  color: #6c757d;
  font-size: 0.75rem;
  font-weight: 700;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  padding-left: 0.5rem;
}

.search-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.search-list li a {
  display: flex;
  align-items: center;
  padding: 0.6rem 0.5rem;
  border-radius: 4px;
  text-decoration: none;
  color: #495057;
  cursor: pointer;
  transition: background-color 0.2s;
}

.search-list li a:hover {
  background-color: #e9ecef;
}

.search-list li i {
  margin-right: 0.75rem;
  color: #6c757d;
  font-size: 1.1rem;
  width: 20px;
  text-align: center;
}

.w-full {
    width: 100%;
}

.search-list.results-list li a {
  align-items: normal;
}

.search-list.results-list li a div {
  display: flex;
  flex-direction: column;
}

.result-id {
  font-weight: 600;
  font-size: 0.9rem;
  color: #343a40;
}

.result-detail {
  font-size: 0.8rem;
  color: #6c757d;
}

.results-list-icon {
    vertical-align: middle;
    display: flex;
    margin: auto;
}

.results-list-icon > i {
    font-size: 1.3rem !important;
}

.results-list-content {
    width: 100%;
}

.spinner-container {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 2rem 0;
}

.search-list li a.search-item--active {
  background-color: rgba(59, 130, 246, 0.08); /* Light blue tint */
  color: #1e40af; /* Deep blue text */
  padding-left: 0.75rem; /* Shift slightly to the right */
  border-left: 3px solid #3b82f6; /* Accent color bar */
  border-radius: 0 4px 4px 0; /* Corner styling matching left border */
  transition: all 0.15s ease-in-out;
}
.search-list li a.search-item--active .result-id {
  color: #1e40af;
}
.search-list li a.search-item--active i {
  color: #3b82f6;
}
</style>